<template>
  <div>
    <div class="complete-schedule">
      <el-breadcrumb
        v-if="step != 0"
        separator-class="el-icon-arrow-right"
        class="step-breadcrumb"
      >
        <el-breadcrumb-item
          v-for="(item, index) in typeForm.type"
          :key="item.label"
          :class="{
            'is-active': index == step - 1,
          }"
        >
          <span @click="stepJump(index)">{{ item.label }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <h3 v-else-if="step == 0">选择操作类型</h3>
      <!-- <h3>
        <template v-if="title.value == 'flight'">
          选择{{ title.label }}角度
        </template>
        <template v-else-if="title.value == 'terrain'"> 设置地形隐藏 </template>
        <template v-else-if="title.value == 'underground'">
          设置环境透明
        </template>
        <template v-else-if="title.value == 'animation'">
          设置动画初始配置
        </template>
        <template v-else> 选择{{ title.label }}资源 </template>
        <span
          v-if="
            step > 0 && typeForm.type.length > 0 && step <= typeForm.type.length
          "
        >
          ( {{ step }}/{{ typeForm.type.length }} )
        </span>
      </h3> -->
    </div>
    <div v-show="previewStatus">
      <!-- 第一步 -->
      <div v-if="step == 0" class="step first-step">
        <el-form
          :rules="typeRules"
          :model="typeForm"
          :validate-on-rule-change="false"
          ref="typeForm"
          label-width="140px"
        >
          <el-form-item style="width: 95%" label="普通操作类型" prop="type">
            <el-select
              style="width: 100%"
              v-model="typeForm.type"
              filterable
              multiple
              clearable
              placeholder="请选择操作类型"
              :popper-append-to-body="false"
              @input="typInput"
            >
              <el-option-group
                v-for="group in options.add"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  :disabled="ifTypDisabled(item)"
                >
                  <span :class="item.class">{{ item.label }}</span>
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item style="width: 95%" label="操作名称" prop="name">
            <el-input v-model="typeForm.name"></el-input>
          </el-form-item>
          <div class="submit">
            <el-button type="primary" @click="selectAction('typeForm')">
              下一步
            </el-button>
          </div>
        </el-form>
      </div>
      <!-- 第二步 -->
      <template v-if="step < typeForm.type.length + 1 && configure">
        <div
          v-for="(item, index) in typeForm.type"
          :key="index"
          class="step second-step"
        >
          <div v-if="step == index + 1">
            <!-- 显示隐藏操作 -->
            <template v-if="item.value == 'show' || item.value == 'hide'">
              <el-form :validate-on-rule-change="false" label-width="140px">
                <!-- <el-form-item
            v-for="(x, i) in configure[item.value]"
            :key="i"
            :label="`选择${x.title}`"
          >
            <el-cascader
              v-model="x.model"
              :options="resourceOptions[i]"
              :props="{
                label: 'title',
                value: 'id',
                multiple: true,
                emitPath: false,
              }"
              multiple
              clearable
              :show-all-levels="false"
              style="width: 95%;"
            ></el-cascader>
          </el-form-item> -->
                <!-- <el-form :validate-on-rule-change="false" label-width="140px"> -->
                <el-form-item label="">
                  <div
                    v-for="(x, i) in configure[item.value]"
                    :key="x.id"
                    class="options-tree"
                  >
                    <el-tree
                      v-if="
                        (resourceOptions[i][0] &&
                          resourceOptions[i][0].children &&
                          resourceOptions[i][0].children.length > 0) ||
                          (resourceOptions[i][1] &&
                            resourceOptions[i][1].children &&
                            resourceOptions[i][1].children.length > 0)
                      "
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      :data="resourceOptions[i]"
                      :props="{
                        label: 'title',
                        value: 'id',
                      }"
                      :default-checked-keys="x.model"
                      @check="
                        (data, checked) => {
                          handleCheckChange(data, checked, i, x);
                        }
                      "
                      :ref="`optionsTree${i}`"
                    ></el-tree>
                    <p class="options-tree-text" v-else>
                      <!-- {{ resourceOptions[i][0].title }} -->
                    </p>
                  </div>
                </el-form-item>
                <!-- </el-form> -->
                <div class="submit">
                  <el-button
                    type="primary"
                    v-if="operationLabel == '编辑操作'"
                    @click="submitExit()"
                  >
                    保存并退出
                  </el-button>
                  <el-button type="primary" @click="previous()">
                    上一步
                  </el-button>
                  <el-button type="primary" @click="nextStep()">
                    下一步
                  </el-button>
                </div>
              </el-form>
            </template>
            <!-- 飞行 -->
            <template v-if="item.value == 'flight'">
              <el-form label-width="140px">
                <el-form-item :label="`选择视角`">
                  <el-button
                    type="primary"
                    :disabled="ifPhotoGraphic"
                    @click="chooseFlightAngle(configure[item.value].flight)"
                    >开始选择</el-button
                  >
                </el-form-item>
              </el-form>

              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>

                <photoGraphic
                  v-if="ifPhotoGraphic"
                  v-model="flightData"
                  :modelPreview="modelPreview"
                ></photoGraphic>
              </div>
            </template>
            <!-- 环境透明 -->
            <template v-if="item.value == 'underground'">
              <el-form label-width="140px">
                <el-form-item style="width: 95%" :label="`环境透明`">
                  <el-input
                    type="number"
                    v-model.number="configure[item.value].opacity.model"
                    max="1"
                    min="0"
                    step="0.1"
                  ></el-input>
                </el-form-item>
              </el-form>
              <!-- {{ resourceOptions }} -->
              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div></template
            >

            <template v-if="item.value == 'dyeing' && resourceOptions">
              <Dyeing
                :configureModel="dyeingSoloCascader"
                :resourceOptionsModel="resourceOptions.model"
                v-model="dyeingSelectModel"
                @dyeingSelectChange="dyeingSelectChange(arguments)"
              ></Dyeing>
              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div></template
            >
            <template v-if="item.value == 'roaming'">
              <Roaming v-model="roamingData"></Roaming>

              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>
            <template v-if="item.value == 'split'">
              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>
            <!-- 分屏 -->
            <template v-if="item.value == 'splitScreen'">
              <Compare
                v-model="compareData"
                :configure="configure"
                :resourceOptions="resourceOptions"
                :sectioningOptions="options.sectioning"
                ref="compare"
              ></Compare>

              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>
            <template v-if="item.value == 'terrain'">
              <el-form label-width="140px">
                <el-form-item :label="`地形服务`">
                  <el-switch v-model="terrainSwitch"></el-switch>
                </el-form-item>
              </el-form>

              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>
            <template v-if="item.value == 'animation2'">
              <Animation
                v-model="animation2"
                :resourceOptions="resourceOptions"
              ></Animation>
              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>

            <template v-if="item.value == 'animation'">
              <el-form label-width="140px">
                <el-form-item style="width: 95%" :label="`选择方案`">
                  <el-select
                    v-model="configure[item.value].animation.model"
                    placeholder="请选择"
                    style="width: 100%"
                    collapse-tags
                  >
                    <el-option
                      v-for="item in options.animation"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>

              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>

            <template v-if="item.value == 'fixedRoute'">
              <el-form label-width="140px">
                <el-form-item style="width: 95%" :label="`类型`">
                  <el-radio-group
                    @input="inputfixedRouteType($event, item.value)"
                    v-model="fixedRouteType"
                  >
                    <el-radio :label="1">自定义模拟</el-radio>
                    <el-radio :label="2">PTV仿真</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  style="width: 95%"
                  :label="`选择`"
                  v-show="fixedRouteType == 1"
                >
                  <el-select
                    v-model="configure[item.value].fixedRoute.model"
                    multiple
                    placeholder="请选择"
                    style="width: 100%"
                    collapse-tags
                    key="fixedRouteType1"
                  >
                    <el-option
                      v-for="item in options.traffic"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="width: 95%"
                  :label="`选择`"
                  v-show="fixedRouteType == 2"
                >
                  <el-select
                    v-model="configure[item.value].fixedRoute.model"
                    multiple
                    placeholder="请选择"
                    style="width: 100%"
                    collapse-tags
                    key="fixedRouteType2"
                  >
                    <el-option
                      v-for="item in options.traffic_ptv"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>

            <template v-if="item.value == 'sectioning'">
              <el-form label-width="140px">
                <el-form-item style="width: 95%" :label="`选择方案`">
                  <el-select
                    v-model="configure[item.value].sectioning.model"
                    multiple
                    placeholder="请选择"
                    style="width: 100%"
                    collapse-tags
                  >
                    <el-option
                      v-for="item in options.sectioning"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="submit">
                <el-button
                  type="primary"
                  v-if="operationLabel == '编辑操作'"
                  @click="submitExit()"
                >
                  保存并退出
                </el-button>
                <el-button type="primary" @click="previous()">
                  上一步
                </el-button>
                <el-button type="primary" @click="nextStep()">
                  下一步
                </el-button>
              </div>
            </template>
            <!-- {{ item.value }} -->
          </div>
        </div>
      </template>
      <!-- 第三步 -->
      <div v-else>
        <h3>请确认配置</h3>
        <div v-for="(item, index) in typeForm.type" :key="index">
          <h4>{{ item.label }}操作：</h4>
          <template v-if="configure[item.value]">
            <template v-if="item.value == 'dyeing'">
              <div class="action-card">
                模型:
                <p
                  v-for="(dyeingItem, dyeingIndex) in dyeingSelectModel"
                  :key="dyeingIndex"
                >
                  {{ dyeingItem.name }}
                  {{
                    dyeingItem.switch != ""
                      ? "( 着色值：" + dyeingItem.color + " )"
                      : "( 透明度：" + dyeingItem.opacity + " )"
                  }},
                </p>
              </div>
            </template>
            <template v-else-if="item.value == 'terrain'">
              <div class="action-card">
                地形服务：{{ terrainSwitch ? "开启" : "关闭" }}
              </div>
            </template>
            <template v-if="item.value == 'fixedRoute'">
              <div class="action-card">
                <p>完成配置，可预览</p>
              </div></template
            >
            <template
              v-if="item.value == 'sectioning' || item.value == 'animation'"
            >
              <div class="action-card">
                <p>完成配置，可预览</p>
              </div>
            </template>

            <template v-else>
              <p v-for="(x, i) in configure[item.value]" :key="i">
                <template
                  v-if="x.model.length > 0 || getLabel(x.model, i).length > 0"
                >
                  <div class="action-card">
                    <template v-if="typeof getLabel(x.model, i) == 'string'">
                      <div>
                        {{ getLabel(x.model, i, x.title) }}
                      </div>
                    </template>
                    <template v-else>
                      {{ x.title }}:
                      <span v-for="(z, y) in getLabel(x.model, i)" :key="y">
                        {{ z.title }},
                      </span>
                    </template>
                  </div>
                </template>
                <!-- <template v-else>
            <div class="action-card">{{ x.title }}: 空</div>
          </template> -->
              </p>
            </template>
          </template>
          <template v-else
            ><div class="action-card">
              <p>完成配置，可预览</p>
            </div></template
          >
        </div>
        <div class="submit">
          <el-button type="primary" @click="previous()"> 上一步 </el-button>
          <el-button type="primary" @click="preview()"> 预览 </el-button>
          <el-button type="primary" @click="onSubmit()"> 保存 </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { configure } from "./configure.js";
import {
  addBimPlanScenesMethod,
  editBimPlanScenesMethod,
  getBimTrafficSimulationNodeList,
  getBimModeSlicedList,
  detailBimConstructSimGrouping,
} from "@/api/api";
const photoGraphic = () => import("@/components/common/photoGraphic/index.vue");
const Compare = () => import("@/components/tables/compare/Index.vue");
const Roaming = () =>
  import("@/components/tables/program/screenplay/roaming/Index.vue");
const Dyeing = () =>
  import("@/components/tables/program/screenplay/dyeing/index.vue");
const Animation2 = () =>
  import("@/components/tables/program/screenplay/animation/Index.vue");
// src\components\tables\program\screenplay\roaming\Index.vue

import _ from "lodash";
export default {
  name: "add-screenplay",
  components: {
    photoGraphic,
    Compare,
    Roaming,
    Dyeing,
    Animation2,
  },
  props: [
    "resourceOptions",
    "scenesId",
    "screenplayInit",
    "modelPreview",
    "operationLabel",
  ],
  data() {
    return {
      configure: JSON.parse(JSON.stringify(configure)),
      progress: {
        percentage: 0,
        status: "exception",
      },
      step: 0,
      oneUnit: 0,
      title: {
        label: "",
      },
      typeForm: {
        name: "",
        type: [],
      },
      typeRules: {
        type: [
          {
            required: true,
            message: "请至少选择一个操作",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
          },
        ],
      },
      options: {
        add: [
          {
            label: "简单操作",
            options: [
              {
                value: "show",
                label: "显示",
                class: "el-link el-link--primary",
                type: "usually",
              },
              {
                value: "hide",
                label: "隐藏",
                class: "el-link el-link--danger",
                type: "usually",
              },
              {
                value: "flight",
                label: "移动",
                class: "el-link el-link--success",
                type: "usually",
              },
            ],
          },
          {
            label: "复杂操作",
            options: [
              {
                value: "dyeing",
                label: "模型着色 / 透明",
                class: "el-link el-link--warning",
                type: "usually",
              },
              {
                value: "sectioning",
                label: "模型剖切",
                class: "el-link el-link--warning",
                type: "special",
              },
              {
                value: "underground",
                label: "环境透明",
                class: "el-link el-link--warning",
                type: "usually",
              },
              {
                value: "terrain",
                label: "地形服务",
                class: "el-link el-link--warning",
                type: "usually",
              },
              {
                value: "roaming",
                label: "漫游",
                class: "el-link el-link--warning",
                type: "usually",
              },
              {
                value: "splitScreen",
                label: "分屏",
                class: "el-link el-link--warning",
                type: "usually",
              },
              {
                value: "fixedRoute",
                label: "交通模拟",
                class: "el-link el-link--warning",
                type: "usually",
              },
              // {
              //   value: "animation",
              //   label: "施工模拟",
              //   class: "el-link el-link--warning",
              //   type: "animation",
              // },
            ],
          },
        ],
        traffic: [],
        traffic_ptv: [],
        sectioning: [],
        animation: [
          // {
          //   id: "4039215724217012",
          //   name: "银衫桥施工模拟",
          // },
        ],
      },
      submitData: {
        name: "",
        operate: [],
        operationNameList: null,
      },
      previewStatus: true,
      // 飞行
      ifPhotoGraphic: false,
      flightData: null,
      // 分屏
      compareData: {
        mainScreen: [],
        secondaryScreen: [],
        share: {
          mainScreenRoamingData: {
            radio: "1",
            ordinaryId: null,
            delay: false,
            delayTime: 0,
          },
        },
        terrainSwitchMain: true,
        terrainSwitchSecond: true,
        splitScreenMode: "leftRight",
        splitScreenModePercentage: "50",
      },
      // 漫游
      roamingData: {
        radio: "1",
        ordinaryId: null,
        delay: false,
        delayTime: 0,
      },
      // 着色
      dyeingSoloCascader: [],
      dyeingSelectModel: [],

      // 地形开关
      terrainSwitch: true,
      editOperate: false,
      editId: null,
      // 动画
      animation2: {
        type: "2",
        selectTime: [],
        totalTime: "",
        company: "second",
        animationData: [],
      },
      fixedRouteType: 1,
    };
  },
  computed: {
    // ifTypDisabled: function(e) {
    //   this.typeForm.type.find((item) => {
    //     console.log(item.value, e);
    //   });
    //   if (this.typeForm.type.length > 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
  },
  methods: {
    // initEdit
    initEditValue() {
      this.editOperate = false;
      this.editId = null;
    },
    // 判断编辑完成与否，清空编辑内容，初始化
    judgeEditComplete() {
      if (this.editOperate) {
        this.$notify({
          title: "已清除编辑内容",
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
        this.initEditValue();
        this.init();
      }
    },
    // 编辑处理方法
    echoData(data, type) {
      if (type === "edit") {
        this.editOperate = true;
        this.editId = data.id;
      }
      // 先初始化
      this.init();
      const operate = data.operate;
      const nameList = data.name.split(",");

      // 赋值操作名称
      this.typeForm.name = data.name;
      // 赋值操作类型
      if (
        data.operationNameList &&
        JSON.parse(data.operationNameList).length > 0
      ) {
        this.typeForm.type = JSON.parse(data.operationNameList);
      } else {
        this.options.add.forEach((item) => {
          item.options.forEach((etem) => {
            const label = nameList.find((item) => etem.label === item);
            if (label) {
              this.typeForm.type.push(etem);
            }
          });
        });
      }

      // 单独处理分屏和漫游赋值
      operate.forEach((item) => {
        if (item.type == "fixedRoute_ptv" || item.type == "fixedRoute") {
          this.fixedRouteType = item.type == "fixedRoute" ? 1 : 2;
        }
        if (
          item.type === "roaming" ||
          item.type === "rotatePoint" ||
          item.type === "viewpoint"
        ) {
          this.roamingData = {
            radio:
              item.type === "roaming"
                ? "1"
                : item.type === "rotatePoint"
                ? "2"
                : item.type === "viewpoint"
                ? "3"
                : "1",
            ordinaryId: Number(item?.screenplayId),
            delay: item?.delay ? item.delay : false,
            delayTime: item?.delayTime ? item.delayTime / 1000 : 0,
          };
        }
        if (item.type === "splitScreen") {
          const data = JSON.parse(item.property);
          // 获取数据
          this.compareData.mainScreen = JSON.parse(
            JSON.stringify(this.configure)
          );
          this.compareData.secondaryScreen = JSON.parse(
            JSON.stringify(this.configure)
          );
          this.compareData.splitScreenMode =
            data.splitScreenMode || "leftRight";
          this.compareData.splitScreenModePercentage =
            data.splitScreenModePercentage || "50";
          // 处理主屏
          Object.keys(this.compareData.mainScreen).forEach((xtem) => {
            const currentObject = this.compareData.mainScreen[xtem];
            this.editAssignment(
              xtem,
              data.mainScreen[0].operate,
              currentObject,
              "double",
              true
            );
          });
          // 处理副屏
          Object.keys(this.compareData.secondaryScreen).forEach((xtem) => {
            const currentObject = this.compareData.secondaryScreen[xtem];
            this.editAssignment(
              xtem,
              data.secondaryScreen[0].operate,
              currentObject,
              "double",
              false
            );
          });
          // 单独处理分屏漫游
          data.mainScreen[0].operate.forEach((item) => {
            if (
              item.type === "roaming" ||
              item.type === "rotatePoint" ||
              item.type === "viewpoint"
            ) {
              this.compareData.share.mainScreenRoamingData = {
                radio:
                  item.type === "roaming"
                    ? "1"
                    : item.type === "rotatePoint"
                    ? "2"
                    : item.type === "viewpoint"
                    ? "3"
                    : "1",
                ordinaryId: Number(item?.screenplayId),
                delay: item?.delay ? item.delay : false,
                delayTime: item?.delayTime ? item.delayTime / 1000 : 0,
              };
            }
          });
        }
      });

      // 赋值其他值
      Object.keys(this.configure).forEach((xtem) => {
        const currentObject = this.configure[xtem];
        console.log(currentObject, "currentObject");
        this.editAssignment(xtem, operate, currentObject, "single");
      });
    },
    rgbaNum(rgba, index) {
      let val = rgba.match(/(\d(\.\d+)?)+/g);
      return val[index];
    },
    // 编辑赋值
    editAssignment(key, operate, currentObject, judgeParity, isMain) {
      // 显示操作回显
      if (key === "show") {
        operate.forEach((xtem) => {
          if (xtem.executionProperty === "show") {
            if (
              xtem.property === "true" ||
              xtem.property === "add" ||
              (typeof xtem.property === "boolean" && xtem.property)
            ) {
              Object.keys(currentObject).forEach((ytem) => {
                if (ytem === xtem.type) {
                  currentObject[ytem].model.push(xtem.screenplayId);
                }
              });
            }
          }
        });
      }
      // 隐藏操作回显
      if (key === "hide") {
        operate.forEach((xtem) => {
          if (xtem.executionProperty === "show") {
            if (
              xtem.property === "false" ||
              xtem.property === "remove" ||
              (typeof xtem.property === "boolean" && !xtem.property)
            ) {
              Object.keys(currentObject).forEach((ytem) => {
                if (ytem === xtem.type) {
                  currentObject[ytem].model.push(xtem.screenplayId);
                }
              });
            }
          }
        });
      }
      // 飞行操作回显
      if (key === "flight") {
        operate.forEach((xtem) => {
          if (xtem.executionProperty === "flight") {
            this.flightData = JSON.parse(xtem.property);
            Object.keys(currentObject).forEach((ytem) => {
              if (ytem === xtem.type) {
                currentObject[ytem].model.push(JSON.parse(xtem.property));
              }
            });
          }
        });
      }
      // 环境透明回显
      if (key === "underground") {
        operate.forEach((xtem) => {
          if (xtem.executionProperty === "opacity") {
            Object.keys(currentObject).forEach((ytem) => {
              if (ytem === xtem.executionProperty) {
                currentObject[ytem].model = xtem.property;
              }
            });
          }
        });
      }
      // 模型着色回显
      if (key === "dyeing") {
        if (judgeParity === "single") {
          const selectIdList = [];
          const tableList = [];
          operate.forEach((xtem) => {
            if (xtem.executionProperty === "overallStaining") {
              selectIdList.push(xtem.screenplayId);
              if (!isNaN(parseFloat(xtem.property))) {
                tableList.push({
                  id: xtem.screenplayId,
                  name: xtem.screenplayName,
                  color: null,
                  opacity: xtem.property,
                  switch: false,
                });
              } else {
                tableList.push({
                  id: xtem.screenplayId,
                  name: xtem.screenplayName,
                  color: xtem.property,
                  opacity:
                    xtem.property && xtem.property != ""
                      ? this.rgbaNum(xtem.property, 3)
                      : 1,
                  switch: true,
                });
              }
            }
          });
          this.dyeingSoloCascader = selectIdList;
          this.dyeingSelectModel = tableList;
        }
        if (judgeParity === "double") {
          operate.forEach((xtem) => {
            if (xtem.executionProperty === "overallStaining") {
              if (!isNaN(parseFloat(xtem.property))) {
                currentObject.model.model.y.push({
                  id: xtem.screenplayId,
                  name: xtem.screenplayName,
                  color: null,
                  opacity: xtem.property,
                  switch: false,
                });
              } else {
                currentObject.model.model.y.push({
                  id: xtem.screenplayId,
                  name: xtem.screenplayName,
                  color: xtem.property,
                  opacity:
                    xtem.property && xtem.property != ""
                      ? this.rgbaNum(xtem.property, 3)
                      : 1,
                  switch: true,
                });
              }
              currentObject.model.model.x.push(xtem.screenplayId);
            }
          });
        }
      }
      // 地形服务回显
      if (key === "terrain") {
        if (judgeParity === "single") {
          operate.forEach((xtem) => {
            if (xtem.type === "terrain") {
              let bool = null;
              if (typeof xtem.property === "boolean") {
                bool = xtem.property;
              }
              if (typeof xtem.property === "string") {
                bool =
                  xtem.property === "false"
                    ? false
                    : xtem.property === "true"
                    ? true
                    : true;
              }
              this.terrainSwitch = bool;
            }
          });
        }
        if (judgeParity === "double") {
          operate.forEach((xtem) => {
            if (xtem.type === "terrain") {
              if (isMain) {
                this.compareData.terrainSwitchMain = xtem.property;
              } else {
                this.compareData.terrainSwitchSecond = xtem.property;
              }
            }
          });
        }
      }
      // 交通模拟
      if (key === "fixedRoute") {
        operate.forEach((xtem) => {
          if (xtem.executionProperty === "operate") {
            Object.keys(currentObject).forEach((ytem) => {
              currentObject[ytem].model.push(parseInt(xtem.screenplayId));
            });
          }
        });
      }
      // 模型剖切
      if (key === "sectioning") {
        operate.forEach((xtem) => {
          if (
            xtem.executionProperty === "start" &&
            xtem.type === "sectioning"
          ) {
            Object.keys(currentObject).forEach((ytem) => {
              currentObject[ytem].model.push(parseInt(xtem.screenplayId));
            });
          }
        });
      }

      if (key === "animation") {
        operate.forEach((xtem) => {
          if (xtem.executionProperty === "start" && xtem.type === "animation") {
            Object.keys(currentObject).forEach((ytem) => {
              currentObject[ytem].model = parseInt(xtem.screenplayId);
            });
          }
        });
      }

      console.log("数据回显", key, operate, currentObject);
    },
    // 监听子组件
    dyeingSelectChange(data) {
      this.dyeingSelectModel = data[0];
      this.dyeingSoloCascader = data[1];
    },
    selectAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.oneUnit = 100 / (this.typeForm.type.length + 1);
          this.nextStep();
        } else {
          return false;
        }
      });
    },
    // 下一步
    nextStep() {
      console.log(this.configure);
      let percentage,
        status = "exception";
      this.step += 1;

      if (this.step == this.typeForm.type.length + 1) {
        percentage = this.step * this.oneUnit;
        if (percentage >= 50) {
          status = "success";
        }
        this.title.label = "完成配置请确认提交";
        this.progress = {
          percentage,
          status,
        };
        this.dataProcessing();
      } else {
        percentage = this.step * this.oneUnit;
        if (percentage >= 50) {
          status = "success";
        }
        this.title = JSON.parse(
          JSON.stringify(this.typeForm.type[this.step - 1])
        );
        this.progress = {
          percentage,
          status,
        };
      }
    },
    // 上一步
    previous() {
      let percentage,
        status = "exception";
      this.step -= 1;
      percentage = this.step * this.oneUnit;
      if (this.step == 0) {
        percentage = this.step * this.oneUnit;
        if (percentage >= 50) {
          status = "success";
        }
        this.title.label = "";
        this.progress = {
          percentage,
          status,
        };
      } else {
        screenplay.initial("notAutomatically");
        percentage = this.step * this.oneUnit;
        if (percentage >= 50) {
          status = "success";
        }
        this.title = JSON.parse(
          JSON.stringify(this.typeForm.type[this.step - 1])
        );
        this.progress = {
          percentage,
          status,
        };
      }
    },
    // 预览
    preview() {
      screenplay.page(this.submitData);
      console.log("预览", this.submitData);
      this.modelPreview();
    },
    // 提交
    onSubmit: _.debounce(function() {
      this.submitData.name = this.typeForm.name;
      this.submitData.operationNameList = JSON.stringify(this.typeForm.type);
      this.submitData.operate.forEach((x) => {
        if (
          (x.type == "flight" || x.type == "splitScreen") &&
          typeof x.property != "string"
        ) {
          x.property = JSON.stringify(x.property);
        }
      });
      // 新增
      if (!this.editOperate) {
        console.log(this.submitData.operate, "this.submitData.operate");
        addBimPlanScenesMethod({
          name: this.submitData.name,
          operate: this.submitData.operate,
          operationNameList: this.submitData.operationNameList,
          scenesId: this.scenesId,
          projectId: window.sessionStorage.getItem("nowProjectId"),
        })
          .then((res) => {
            let { code } = res.data;
            this.initEditValue();
            if (code == 200 || code == 204) {
              this.screenplayInit();
              this.$notify({
                title: "新增成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.$NProgress.done(true);
            } else {
              this.$notify({
                title: "新增失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
              this.$NProgress.done(true);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              title: "新增失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          });
      } else {
        // 编辑
        editBimPlanScenesMethod({
          name: this.submitData.name,
          operate: this.submitData.operate,
          operationNameList: this.submitData.operationNameList,
          scenesId: this.scenesId,
          projectId: window.sessionStorage.getItem("nowProjectId"),
          id: this.editId,
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.screenplayInit();
              this.initEditValue();
              this.$notify({
                title: "编辑成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              this.$notify({
                title: "编辑失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((error) => {
            this.$notify({
              title: "编辑失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      }
    }, 500),
    // 最后一步
    dataProcessing() {
      // 显示 隐藏是同一个类型
      screenplay.initial("notAutomatically");
      let data = [];

      this.typeForm.type.forEach((item) => {
        console.log(this.configure[item.value]);
        if (item.value != "splitScreen") {
          data.push.apply(
            data,
            this.processingSubmittedData(item, this.configure[item.value])
          );
        } else {
          data.push.apply(
            data,
            this.processingSubmittedData(item, this.compareData)
          );
        }
      });
      console.log("最终数据", data);
      this.submitData.operate = data;
    },
    // 封装数据
    processingSubmittedData(typeItem, configureItem) {
      let type,
        operate = [];
      type = typeItem.value;
      console.log("类型", type);
      switch (type) {
        case "show":
          Object.keys(configureItem).forEach((key) => {
            if (configureItem[key].model.length > 0) {
              configureItem[key].model.forEach((item) => {
                operate.push({
                  screenplayType: "usually",
                  type: key,
                  screenplayId: item,
                  executionProperty: "show",
                  property: key == "model" ? "add" : true,
                });
              });
            }
          });
          break;
        case "hide":
          Object.keys(configureItem).forEach((key) => {
            if (configureItem[key].model.length > 0) {
              configureItem[key].model.forEach((item) => {
                operate.push({
                  screenplayType: "usually",
                  type: key,
                  screenplayId: item,
                  executionProperty: "show",
                  property: key == "model" ? "remove" : false,
                });
              });
            }
          });
          break;
        case "flight":
          Object.keys(configureItem).forEach((key) => {
            if (configureItem[key].model.length > 0) {
              configureItem[key].model.forEach((item) => {
                operate.push({
                  screenplayType: "usually",
                  type: key,
                  screenplayId: "",
                  executionProperty: "flight",
                  property: item,
                });
              });
            }
          });
          break;
        case "splitScreen":
          console.log(
            "双屏",
            configureItem,
            this.compareData.share.mainScreenRoamingData
          );
          operate.push({
            type: "splitScreen",
            screenplayType: "usually",
            id: "",
            executionProperty: "open",
            property: {
              splitScreenMode: configureItem.splitScreenMode || "leftRight",
              splitScreenModePercentage:
                configureItem.splitScreenModePercentage || "50",
              mainScreen: [
                {
                  type: "usually",
                  operate: [],
                },
              ],
              secondaryScreen: [
                {
                  type: "usually",
                  operate: [],
                },
              ],
            },
          });
          // 主屏
          Object.keys(configureItem.mainScreen).forEach((item) => {
            Object.keys(configureItem.mainScreen[item]).forEach((x) => {
              if (
                configureItem.mainScreen[item][x].model.length > 0 ||
                (typeof configureItem.mainScreen[item][x].model != "object" &&
                  configureItem.mainScreen[item][x].model != null) ||
                Object.keys(configureItem.mainScreen[item][x].model).length > 0
              ) {
                if (item == "show") {
                  configureItem.mainScreen[item][x].model.forEach((z) => {
                    operate[0].property.mainScreen[0].operate.push({
                      screenplayType: "usually",
                      type: x,
                      screenplayId: z,
                      executionProperty: "show",
                      property: x == "model" ? "add" : true,
                    });
                  });
                } else if (item == "hide") {
                  configureItem.mainScreen[item][x].model.forEach((z) => {
                    operate[0].property.mainScreen[0].operate.push({
                      screenplayType: "usually",
                      type: x,
                      screenplayId: z,
                      executionProperty: "show",
                      property: x == "model" ? "remove" : false,
                    });
                  });
                } else if (item == "underground") {
                  operate[0].property.mainScreen[0].operate.push({
                    screenplayType: "usually",
                    type: "underground",
                    screenplayId: "",
                    executionProperty: "opacity",
                    property: configureItem.mainScreen[item][x].model,
                  });
                } else if (item == "dyeing") {
                  configureItem.mainScreen["dyeing"].model.model["y"].forEach(
                    (item) => {
                      console.log(item);
                      if (item.switch) {
                        operate[0].property.mainScreen[0].operate.push({
                          screenplayType: "usually",
                          type: "model",
                          screenplayId: item.id,
                          executionProperty: "overallStaining",
                          property: item.color,
                        });
                      } else {
                        operate[0].property.mainScreen[0].operate.push({
                          screenplayType: "usually",
                          type: "model",
                          screenplayId: item.id,
                          executionProperty: "overallStaining",
                          property: item.opacity,
                        });
                      }
                    }
                  );
                  // operate[0].property.mainScreen[0].operate 处理的数据 push
                } else if (item == "terrain") {
                  operate[0].property.mainScreen[0].operate.push({
                    screenplayType: "usually",
                    type: "terrain",
                    screenplayId: "",
                    executionProperty: "show",
                    property: this.compareData.terrainSwitchMain,
                  });
                } else if (item == "sectioning") {
                  configureItem.mainScreen[item][x].model.forEach(
                    (modelItem) => {
                      operate[0].property.mainScreen[0].operate.push({
                        screenplayType: "special",
                        type: "sectioning",
                        screenplayId: modelItem,
                        executionProperty: "start",
                        property: "true",
                      });
                    }
                  );

                  // console.log(
                  //   "处理数据",
                  //   configureItem.mainScreen[item][x].model,
                  //   this.compareData,
                  //   operate[0].property.mainScreen[0].operate
                  // );
                }
              }
            });
          });
          // 主屏漫游
          let roamingData;
          switch (this.compareData.share.mainScreenRoamingData.radio) {
            case "1":
              if (this.compareData.share.mainScreenRoamingData.ordinaryId) {
                roamingData = {
                  screenplayType: "usually",
                  type: "roaming",
                  screenplayId: this.compareData.share.mainScreenRoamingData
                    .ordinaryId,
                  executionProperty: "operate",
                  property: "start",
                };
              }

              break;
            case "2":
              roamingData = {
                screenplayType: "usually",
                type: "rotatePoint",
                screenplayId: "",
                executionProperty: "fly",
                property: "start",
              };
              break;
            case "3":
              roamingData = {
                screenplayType: "special",
                type: "viewpoint",
                screenplayId: this.compareData.share.mainScreenRoamingData
                  .ordinaryId,
                executionProperty: "operate",
                property: "start",
              };
              break;
          }
          if (roamingData) {
            if (this.compareData.share.mainScreenRoamingData.delay) {
              roamingData.delay = this.compareData.share.mainScreenRoamingData.delay;
              roamingData.delayTime =
                this.compareData.share.mainScreenRoamingData.delayTime * 1000;
            }
            operate[0].property.mainScreen[0].operate.push(roamingData);
          }

          // 副屏
          Object.keys(configureItem.secondaryScreen).forEach((item) => {
            Object.keys(configureItem.secondaryScreen[item]).forEach((x) => {
              if (
                configureItem.secondaryScreen[item][x].model.length > 0 ||
                (typeof configureItem.mainScreen[item][x].model != "object" &&
                  configureItem.secondaryScreen[item][x].model != null) ||
                Object.keys(configureItem.secondaryScreen[item][x].model)
                  .length > 0
              ) {
                // 筛选出来的操作
                if (item == "show") {
                  configureItem.secondaryScreen[item][x].model.forEach((z) => {
                    operate[0].property.secondaryScreen[0].operate.push({
                      screenplayType: "usually",
                      type: x,
                      screenplayId: z,
                      executionProperty: "show",
                      property: x == "model" ? "add" : true,
                      list: { mapType: "clone" },
                    });
                  });
                } else if (item == "hide") {
                  configureItem.secondaryScreen[item][x].model.forEach((z) => {
                    operate[0].property.secondaryScreen[0].operate.push({
                      screenplayType: "usually",
                      type: x,
                      screenplayId: z,
                      executionProperty: "show",
                      property: x == "model" ? "remove" : false,
                      list: { mapType: "clone" },
                    });
                  });
                } else if (item == "underground") {
                  operate[0].property.secondaryScreen[0].operate.push({
                    screenplayType: "usually",
                    type: "underground",
                    screenplayId: "",
                    executionProperty: "opacity",
                    property: configureItem.secondaryScreen[item][x].model,
                    list: { mapType: "clone" },
                  });
                } else if (item == "dyeing") {
                  configureItem.secondaryScreen["dyeing"].model.model[
                    "y"
                  ].forEach((item) => {
                    if (item.switch) {
                      operate[0].property.secondaryScreen[0].operate.push({
                        screenplayType: "usually",
                        type: "model",
                        screenplayId: item.id,
                        executionProperty: "overallStaining",
                        property: item.color,
                        list: { mapType: "clone" },
                      });
                    } else {
                      operate[0].property.secondaryScreen[0].operate.push({
                        screenplayType: "usually",
                        type: "model",
                        screenplayId: item.id,
                        executionProperty: "overallStaining",
                        property: item.opacity,
                        list: { mapType: "clone" },
                      });
                    }
                    // operate[0].property.secondaryScreen[0].operate.push({
                    //   screenplayType: "usually",
                    //   type: "model",
                    //   screenplayId: item.id,
                    //   executionProperty: "overallStaining",
                    //   property: item.color,
                    //   list: { mapType: "clone" },
                    // });
                  });
                } else if (item == "terrain") {
                  operate[0].property.secondaryScreen[0].operate.push({
                    screenplayType: "usually",
                    type: "terrain",
                    screenplayId: "",
                    executionProperty: "show",
                    property: this.compareData.terrainSwitchSecond,
                    list: { mapType: "clone" },
                  });
                } else if (item == "sectioning") {
                  configureItem.secondaryScreen[item][x].model.forEach(
                    (modelItem) => {
                      operate[0].property.secondaryScreen[0].operate.push({
                        screenplayType: "special",
                        type: "sectioning",
                        screenplayId: modelItem,
                        executionProperty: "start",
                        property: "true",
                        list: { mapType: "clone" },
                      });
                    }
                  );
                  // operate[0].property.secondaryScreen[0].operate.push({
                  //   screenplayType: "special",
                  //   type: "sectioning",
                  //   screenplayId: configureItem.secondaryScreen[item][x].model,
                  //   executionProperty: "start",
                  //   property: "true",
                  //   list: { mapType: "clone" },
                  // });
                }
              }
            });
          });

          break;
        case "underground":
          Object.keys(configureItem).forEach((key) => {
            if (
              (!isNaN(parseFloat(configureItem[key].model)) &&
                isFinite(configureItem[key].model)) ||
              configureItem[key].model
            ) {
              operate.push({
                screenplayType: "usually",
                type: type,
                screenplayId: "",
                executionProperty: key,
                property: configureItem[key].model,
              });
            }
          });
          break;

        case "dyeing":
          this.dyeingSelectModel.forEach((key) => {
            if (key.switch) {
              operate.push({
                screenplayType: "usually",
                type: "model",
                screenplayId: key.id,
                executionProperty: "overallStaining",
                property: key.color,
              });
            } else {
              operate.push({
                screenplayType: "usually",
                type: "model",
                screenplayId: key.id,
                executionProperty: "overallStaining",
                property: key.opacity,
              });
            }
          });
          break;
        case "roaming":
          let data;
          switch (this.roamingData.radio) {
            case "1":
              data = {
                screenplayType: "usually",
                type: "roaming",
                screenplayId: this.roamingData.ordinaryId,
                executionProperty: "operate",
                property: "start",
              };
              break;
            case "2":
              data = {
                screenplayType: "usually",
                type: "rotatePoint",
                screenplayId: "",
                executionProperty: "fly",
                property: "start",
              };
              break;
            case "3":
              data = {
                screenplayType: "special",
                type: "viewpoint",
                screenplayId: this.roamingData.ordinaryId,
                executionProperty: "operate",
                property: "start",
              };
              break;
          }
          if (this.roamingData.delay) {
            data.delay = this.roamingData.delay;
            data.delayTime = this.roamingData.delayTime * 1000;
          }
          operate.push(data);
          break;

        case "terrain":
          operate.push({
            screenplayType: "usually",
            type: "terrain",
            screenplayId: "",
            executionProperty: "show",
            property: this.terrainSwitch,
          });
          break;
        case "fixedRoute":
          configureItem.fixedRoute.model.forEach((i) => {
            operate.push({
              screenplayType: "usually",
              type: this.fixedRouteType == 1 ? "fixedRoute" : "fixedRoute_ptv",
              screenplayId: i,
              executionProperty: "operate",
              property: "start",
            });
          });
        //  模型剖切
        case "sectioning":
          configureItem.sectioning?.model.forEach((i) => {
            operate.push({
              screenplayType: "special",
              type: "sectioning",
              screenplayId: i,
              executionProperty: "start",
              property: "true",
            });
          });
          break;
        //  动画
        case "animation":
          operate.push({
            screenplayType: "special",
            type: "animation",
            screenplayId: configureItem.animation?.model,
            executionProperty: "start",
            property: "true",
          });
          break;
      }
      return operate;
    },
    // 根据id 返回模型名称

    getLabel(data, type, title) {
      if (
        type == "kml" ||
        type == "shp" ||
        type == "plot" ||
        type == "model" ||
        type == "pit"
      ) {
        let arr = [];
        if (type == "plot") {
          data.forEach((item) => {
            this.resourceOptions[type].forEach((z) => {
              if (z.children[0].children.length > 0) {
                z.children.forEach((i) => {
                  i.children.find((o) => {
                    if (o.id == item) {
                      arr.push(o);
                    }
                  });
                });
              } else {
                z.children.find((o) => {
                  if (o.id == item) {
                    arr.push(o);
                  }
                });
              }
            });
          });
        } else if (type != "plot" && this.resourceOptions[type][0]?.children) {
          let processingData = [];
          let DeleteEmptyChildren = (data) => {
            if (data) {
              data.forEach((item, index) => {
                if (item.children == undefined) {
                  return processingData.push(item);
                } else {
                  DeleteEmptyChildren(item.children);
                }
              });
            }
          };
          DeleteEmptyChildren(this.resourceOptions[type]);
          if (data instanceof Array)
            data.forEach((item) => {
              processingData.find((o) => {
                if (o.id == item) {
                  arr.push(o);
                }
              });
            });
        } else {
          data.forEach((item) => {
            this.resourceOptions[type].forEach((z) => {
              z.children.find((o) => {
                if (o.id == item) {
                  arr.push(o);
                }
              });
            });

            // this.resourceOptions[type][0]?.children.find((o) => {
            //   if (o.id == item) {
            //     arr.push(o);
            //   }
            // });
          });
        }

        return arr;
      } else if (type == "flight") {
        if (data.length > 0) {
          let arr1 = [];
          Object.keys(data[0]).forEach((key) => {
            arr1.push([key, data[0][key]].join("="));
          });
          return "坐标是 " + arr1.toString();
        } else {
          return "暂无飞行";
        }
      } else {
        return title + ": " + data.toString();
      }
    },
    // 关闭模态框
    chooseFlightAngle(item) {
      item.model = [];
      this.flightData = item.model;
      this.modelPreview();
      this.ifPhotoGraphic = true;
    },
    // 选择操作类型
    typInput(e) {
      let text = [];
      e.forEach((item) => {
        console.log(item.label);
        text.push(item.label);
      });
      this.typeForm.name = text.toString();
    },
    // 双屏做判断
    ifTypDisabled(e) {
      // if(e)
      console.log(e, this.typeForm.type[0]?.value);
      // if (this.typeForm.type[0]?.value == "animation") {
      //   if (e.value == "animation") {
      //     return false;
      //   } else {
      //     return true;
      //   }
      // } else {
      // return false;
      if (
        this.typeForm.type.length == 0 ||
        e.value == "flight" ||
        (this.typeForm.type.length == 1 &&
          this.typeForm.type[0].value == "flight")
      )
        return false;
      let disabledArr = [];
      if (typeof this.typeForm.type === "string") {
        this.typeForm.type = JSON.parse(this.typeForm.type);
      }
      this.typeForm.type.find((item) => {
        if (item.value == "splitScreen") {
          disabledArr.push(item.value);
        }
      });
      if (disabledArr.length == 0) {
        if (e.value != "splitScreen") {
          return false;
        } else {
          return true;
        }
      } else {
        if (e.value == "splitScreen") {
          return false;
        } else {
          return true;
        }
      }
      // }
    },
    init() {
      this.configure = JSON.parse(JSON.stringify(configure));
      this.step = 0;
      this.typeForm.type = [];
      this.typeForm.name = "";
      this.progress = {
        percentage: 0,
        status: "exception",
      };
      this.title = {
        label: "",
      };
      getBimTrafficSimulationNodeList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        dataType: 1,
      }).then((res) => {
        let { code, data } = res.data;
        console.log("交通", code, data, this.scenesId);
        this.options.traffic = data;
      });
      getBimTrafficSimulationNodeList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        dataType: 2,
      }).then((res) => {
        let { data } = res.data;
        this.options.traffic_ptv = data;
      });
      getBimModeSlicedList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        businessId: this.scenesId,
        dataType: 2,
      }).then((res) => {
        let { code, data } = res.data;
        this.options.sectioning = data;
      });
      detailBimConstructSimGrouping({
        sceneId: this.scenesId,
      }).then((res) => {
        let { code, data } = res.data;
        this.options.animation = data;
      });
    },
    // 树行选择
    handleCheckChange(data, checked, type, item) {
      item.model = this.$refs[`optionsTree${type}`][0].getCheckedKeys(true);
    },
    inputfixedRouteType(v, d) {
      this.configure[d].fixedRoute.model = "";
      if (v == 1) {
        getBimTrafficSimulationNodeList({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          dataType: 1,
        }).then((res) => {
          let { code, data } = res.data;
          console.log("交通", code, data, this.scenesId);
          this.options.traffic = data;
        });
      } else {
        getBimTrafficSimulationNodeList({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          dataType: 2,
        }).then((res) => {
          console.log(res);
          let { data } = res.data;
          this.options.traffic_ptv = data;
        });
      }
    },
    stepJump(index) {
      console.log(index);
      this.step = index + 1;
      this.title = JSON.parse(
        JSON.stringify(this.typeForm.type[this.step - 1])
      );
    },
    submitExit() {
      this.dataProcessing();
      this.onSubmit();
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "typeForm.type": (e) => {
      console.log(e);
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.el-table::before {
  height: 0px;
}
.second-step > div {
  margin-bottom: 10px;
}
.second-step {
  /deep/ .el-radio .el-radio__label {
    // color: #606266 !important;
    font-size: 14px !important;
  }
  /deep/ .el-radio .el-radio__input.is-checked .el-radio__inner,
  .el-radio .el-radio__input.is-checked .el-radio__inner {
    background-color: #409eff !important;
    border-color: #409eff !important;
  }
}
.screenplay-box {
  padding: 20px;
  // background-color: #fff;
}
.complete-schedule {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  /* color: ; */
}
.submit {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9999999;
  /deep/ .el-button--primary:hover,
  /deep/ .el-button--primary:hover {
    background-color: #66b1ff !important;
    border-color: #66b1ff !important;
  }
}

.action-card {
  padding-left: 36px;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  color: rgba(255, 255, 255, 0.9) !important;
  > div {
    margin-left: 5px;
  }
  > span {
    margin-left: 5px;
  }
}
.options-tree {
  margin-bottom: 15px;
  /deep/ .el-tree {
    background: transparent;
  }
  /deep/ .el-tree-node__label {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9) !important;
    line-height: 16px;
  }
  /deep/ .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  /deep/ .el-tree-node__content:hover {
    background-color: transparent;
  }
  /deep/ .el-tree-node__content .el-checkbox__input {
    height: 16px;
  }
  /deep/ .el-tree-node__content > label.el-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    font-size: 16px;
    height: 18px;
    top: 0;
    bottom: 0;
  }
  /deep/ .el-checkbox__inner::after {
    height: 8px;
    left: 5px;
  }
  .options-tree-text {
    line-height: initial;
    margin: 0;
    font-size: 16px;
    padding-left: 50px;
    color: #606266;
  }
}
h3,
h4 {
  color: rgba(255, 255, 255, 0.9) !important;
}
/deep/ .el-form-item__label {
  color: rgba(255, 255, 255, 0.9) !important;
}
/deep/ .el-input__inner {
  background: transparent;
  color: rgba(255, 255, 255, 0.9) !important;
}
/deep/ .el-scrollbar__wrap {
  margin-top: 0px !important;
  padding-bottom: 15px !important;
  max-height: 385px;
}

.step-breadcrumb {
  font-size: 18px;
  color: #fff;
  margin: 15px 0 35px 0;
  /deep/.el-breadcrumb__inner {
    color: #fff;
    cursor: pointer !important;
    &:hover {
      color: #66b1ff;
    }
  }
  /deep/ .el-breadcrumb__item.is-active {
    .el-breadcrumb__inner {
      color: #66b1ff;
      font-weight: bold;
    }
  }
}
</style>
